/* A titled block inside a form.
 *
 * The client's document is organised into named sections — "Add field",
 * "Features needed for this group", "Privacy settings" — and they will read
 * these screens looking for those headings. One component so the rule stays
 * the same everywhere: a rule above, the heading, then the content.
 */
import type { ReactNode } from 'react'

export function Section({
  title,
  children,
}: {
  title: string
  children: ReactNode
}) {
  return (
    <section className="border-t border-line-2 pt-s4">
      <h2 className="mb-s3 text-md font-bold">{title}</h2>
      {children}
    </section>
  )
}
